import api from './BaseApi';

export function buyRegularMenu(payload, update = false, id) {
  if (update) {
    return api.post(`subscription/${id}/update`, payload);
  }
  return api.post('subscription/add', payload);
}

export function buySpecialMenu(payload, update = false, id) {
  if (update) {
    return api.post(`user_recipe_set/${id}/update`, payload);
  }
  return api.post('user_recipe_set/add', payload);
}

export function addUserToMenu(payload) {
  return api.post('profile_subscription_meal/add', payload);
}

export function removeUserFromMenu({ id }) {
  return api.post(`profile_subscription_meal/${id}/delete`);
}

export function editUserInMenu({ id }, payload) {
  return api.post(`profile_subscription_meal/${id}/edit`, payload)
}

export function addUserToSet(payload) {
  return api.post('profile_recipe_set/add', payload);
}

export function removeUserFromSet({ id }) {
  return api.post(`profile_recipe_set/${id}/delete`);
}